var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { flat: "", color: "transparent" } },
    [
      _vm.query
        ? _c(
            "v-card-title",
            {
              staticClass: "card-bg-2 title py-2 overflow-hidden",
              staticStyle: { "flex-wrap": "nowrap" },
            },
            [
              _c("v-icon", { staticClass: "mr-2" }, [_vm._v("label")]),
              _vm._v(" "),
              _c("div", { staticClass: "overflow-hidden" }, [
                _vm._v("\n      " + _vm._s(_vm.query.name) + "\n    "),
              ]),
            ],
            1
          )
        : _c(
            "v-card-title",
            { staticClass: "card-bg-2 title py-2" },
            [
              _c("v-icon", { staticClass: "mr-2" }, [_vm._v("label")]),
              _vm._v("\n    New Query\n  "),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }